import { numberWithCommas } from "common/number";
import { Button } from "components/button";
import { Link } from "react-router-dom";
import paths from "routes/paths";
import { useAppSelector } from "store";
import { authNewSelectors } from "store/reducers/auth-new";

import css from "./index.module.scss";

export const Credits = () => {
  const countLeft = useAppSelector(authNewSelectors.creditLeftGet);
  const isLoggedIn = useAppSelector(authNewSelectors.loggedInGet);
  const trialActive = useAppSelector(authNewSelectors.trialActiveGet);

  return (
    <div className={css.wrapper}>
      {isLoggedIn && (
        <span className={css.credits}>
          <span>{trialActive ? "Trial credits" : "Credits"}:</span>
          <strong>{numberWithCommas(countLeft)}</strong>
        </span>
      )}
      {!trialActive && (
        <Button
          as={Link}
          className={css.button}
          size="small"
          to={paths.purchase()}
        >
          <span>
            Add <span>Credits</span>
          </span>
        </Button>
      )}
    </div>
  );
};
